import { render, staticRenderFns } from "./NotificationConfigModal.vue?vue&type=template&id=75249852&scoped=true"
import script from "./NotificationConfigModal.vue?vue&type=script&lang=js"
export * from "./NotificationConfigModal.vue?vue&type=script&lang=js"
import style0 from "./NotificationConfigModal.vue?vue&type=style&index=0&id=75249852&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75249852",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75249852')) {
      api.createRecord('75249852', component.options)
    } else {
      api.reload('75249852', component.options)
    }
    module.hot.accept("./NotificationConfigModal.vue?vue&type=template&id=75249852&scoped=true", function () {
      api.rerender('75249852', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/system/components/Modal/NotificationConfigModal.vue"
export default component.exports